import { STORAGE_KEY } from '@/constant/constant';
import { companyUUID, getQueryVariable } from '@/service/api';
import { getCookie, getAllCookies } from '@/utils/cookie';
import { config } from '@/constant/company';
import { getLocal, setLocal } from '@/utils/storage';
import { safeJsonParse } from '@/utils/safeJsonParse';

// 监听时间阈值
const MONITOR_TIME = 1000 * 60 * 30;

const MONITOR_KEYS = ['utm-source', 'UTM_SOURCE_DATA', 'UTM_SOURCE_ARRAY', '_ga'];

export const isEnableMonitor = () => {
  return [config.xike[468], config.shopline[838], config.shopify[565], config.shopify[579]].includes(companyUUID);
};

export const getChangeList = () => {
  // 检测字段列表
  // 重点：utm-source UTM_SOURCE_DATA UTM_SOURCE_ARRAY
  // 可疑：mirage_utm（快照）  mirage_sid（快照）
  const last = safeJsonParse<any[]>(getLocal(STORAGE_KEY.LAST_ACTIVE_INFO), []);
  const current = getInfo();
  const changes = [false, false];

  const ret = [];
  for (let i = 0; i < MONITOR_KEYS.length; i++) {
    // diff
    if (last[i] !== current[i]) {
      if (MONITOR_KEYS[i] === '_ga') {
        changes[0] = true;
      } else if (MONITOR_KEYS[i].includes('_ga_')) {
        changes[1] = true;
      }
      ret.push({ [MONITOR_KEYS[i]]: [last[i], current[i]] });
    }
  }

  let reson;

  if (changes[0] && changes[1]) {
    reson = '均变化';
  } else if (changes[0]) {
    reson = 'GA变化';
  } else if (changes[1]) {
    reson = 'GS变化';
  } else {
    reson = 'OTHER变化';
  }

  return {
    reson,
    list: ret
  };
};

export const getInfo = () => {
  const ret = new Array(MONITOR_KEYS.length);
  for (let i = 0; i < MONITOR_KEYS.length; i++) {
    // console.log(MONITOR_KEYS[i], getCookie(MONITOR_KEYS[i]));
    ret[i] = getCookie(MONITOR_KEYS[i]) || '';
  }
  return ret;
};

export const setInfo = () => {
  const ret = getInfo();
  setLocal(STORAGE_KEY.LAST_ACTIVE_INFO, JSON.stringify(ret));
  return ret;
};

export const track = ({ diff, reson }) => {
  if (!window.cartq) {
    // console.log('没有cartq');
    return;
  }
  const customer = safeJsonParse<any>(getLocal(STORAGE_KEY.CARTX_CUSTOMER), {});
  const phone = window.cartq.params?.customer?.phone || customer?.phone || '';
  const email = window.cartq.params?.customer?.email || customer?.email || '';

  let track = 'track';
  if (companyUUID === config.xike[468]) {
    track = 'track1';
  }
  window.cartq(track, 'Site/AttributionMonitor', {
    pathName: window.location.href,
    email,
    phone,
    diff,
    reson,
    utm: getLocal(STORAGE_KEY.UTM_SOURCE_LIST)
  });
};

// cartsee引流（到站前30分钟静默）用户，到站30分钟内如用户ga用户信息变化，则进行ga用户信息纠正
export const monitorGA = () => {
  if (!isEnableMonitor()) {
    // console.log('[cartsee] 不在灰度白名单');
    return '[cartsee] 不在灰度白名单';
  }

  const allCookies = getAllCookies();
  for (const key in allCookies) {
    // session 可能多个
    if (key.indexOf('_ga_') !== -1) {
      MONITOR_KEYS.push(key);
    }
  }
  // console.log('[cartsee] 所有监控字段', MONITOR_KEYS);

  let timer = null;
  const currentTime = new Date().getTime();
  const lastActiveTime = +getLocal(STORAGE_KEY.LAST_ACTIVE_TIME);
  const lastCartseeTime = +getLocal(STORAGE_KEY.LAST_CACTSEE_ACTIVE_TIME);
  const utmSource = getQueryVariable('utm_source');

  // console.log('[cartsee] 本次到站静默时间', (currentTime - lastActiveTime) / 1000, 's');

  if (utmSource === 'CartSee') {
    // console.log('[cartsee] 当前url为cartsee到站 or 到站30分钟内');
    setLocal(STORAGE_KEY.LAST_CACTSEE_ACTIVE_TIME, currentTime.toString());

    // 判断本次到站事件 - 用户末次非cartsee行为时间戳 > 30分钟 or 末次非cartsee行为时间戳为空
    if (!lastActiveTime || currentTime - lastActiveTime > MONITOR_TIME) {
      setLocal(STORAGE_KEY.LAST_CACTSEE_ACTIVE_GA, getCookie('_ga'));

      // 记录GA信息
      setInfo();

      // 开始3秒监控变化
      // console.log('[cartsee] 开始监控');
      timer = setInterval(() => {
        const { reson, list } = getChangeList();
        if (list.length > 0) {
          // 日志打点
          // console.log('[cartsee] 日志打点 change', reson, JSON.stringify(list, null, 2));
          track({
            diff: JSON.stringify(list),
            reson
          });

          // 更新记录信息
          setInfo();
        }
      }, 3 * 1000);
    }
  } else if (lastCartseeTime && currentTime - lastCartseeTime < MONITOR_TIME) {
    // console.log('[cartsee] 到站跳转');
    // 中间其他utm到站记录
    if (utmSource) {
      const utmSourceList = safeJsonParse<any[]>(getLocal(STORAGE_KEY.UTM_SOURCE_LIST), []);
      const newUtmSourceList = [...utmSourceList, [utmSource, currentTime]];
      setLocal(STORAGE_KEY.UTM_SOURCE_LIST, JSON.stringify(newUtmSourceList));
    }

    // 开始3秒监控变化
    // console.log('[cartsee] 开始监控');
    timer = setInterval(() => {
      const { reson, list } = getChangeList();
      if (list.length > 0) {
        // 日志打点
        // console.log('[cartsee] 日志打点 change', reson, JSON.stringify(list, null, 2));
        track({
          diff: JSON.stringify(list),
          reson
        });
        // 更新记录信息
        setInfo();
      }
    }, 3 * 1000);
  } else {
    // 清空utm记录
    clearInterval(timer);
    setLocal(STORAGE_KEY.UTM_SOURCE_LIST, '[]');
    // console.log('[cartsee] 非监控范围');
  }

  setLocal(STORAGE_KEY.LAST_ACTIVE_TIME, new Date().getTime().toString());
};
